import React, {useCallback, useEffect, useState, useRef} from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  FlatList,
  Platform,
  Animated,
} from "react-native";
import {Color, globalFontStyle, globalStyle} from "../../assets";

import {connect} from "react-redux";
import PortfolioSummary from "./childComponents/portfolioSummary";
import PortfolioLiveCard from "./childComponents/portfolioLiveCard";
import Colors from "../../assets/Color/Colors";
import PortfolioClosedCard from "./childComponents/portfolioClosedCard";
import PortfolioParentClosed from "./childComponents/portfolioParentClosed";
import {Network} from "../../utils/network";
import {fetchLivePorfolio} from "./redux/portfolio.action";
import {selectLiveProbes} from "./redux/portfolio.selector";
import CommonModal from "../../commonComponents/commonModal";
import BuySell from "../event/childComponents/BuySell";
import {
  ORDER_STATUS_CLOSED_CANCEL,
  ORDER_STATUS_CLOSED_SELL,
} from "./portfolio.constants";
import moment from "moment";
import NoMarket from "../../commonComponents/NoMarkets";
import {useFocusEffect} from "@react-navigation/native";
import {getUser} from "../Profile/redux/profile.action";
import {SafeAreaView, useSafeAreaInsets} from "react-native-safe-area-context";
import {isMobile, trackMoengageEvent} from "../../utils/commonMethods";
import {usePolling} from "../../common/usePolling";
import {globalImport} from "../../common/globalImports";
import Header from "../../commonComponents/Header";
import {
  bottomsheet_top,
  errorBlock,
  nothing_card_closed,
  nothing_card_live,
  withdraw_err,
} from "../../utils/images";
import FastImage from "../../common/FastImage";
import Width from "../../assets/Width";
import ClosedPortfolioDetail from "./childScreens/closedPortfolioDetail";
import PortfolioRemoveLiquidity from "./childComponents/portfolioRemoveLiquidity";
import ContestPortfolioLiveCard from "./childComponents/contestPortfolioLiveCard";
import {RefreshControl} from "react-native-web-refresh-control";
import FormTextLabel from "../../commonComponents/FormTextLabel";
import {
  globalConfigurableData,
  GlobalScreens,
} from "../../utils/globalConstant";
import ProtectedRoute from '../../commonComponents/ProtectedRoute';

const Portfolio = ({
  navigation,
  route,
  fetchLivePorfolio: fetchLiveRequest,
  getUser: fetchRequestUser,
  livePortfolioData,
  wsConnected,
  ws,
  contestParentId,
}) => {
  const insets = useSafeAreaInsets();
  const [isLiveSelected, setIsLiveSelected] = useState(true);
  const [loading, setLoading] = useState(false);
  const [closedHeader, setClosedHeader] = useState(null);
  const [selectedOpenProbe, setSelectedOpenProbe] = useState(null);
  const [selectedClosedProbe, setSelectedClosedProbe] = useState(null);
  const [apiRespnseUiData, setApiResponseUiData] = useState({
    isShow: false,
    orderData: null,
  });
  const contestId = route?.params?.contestId || contestParentId;

  const {tab = true} = route?.params !== undefined ? route?.params : true;

  useEffect(() => {
    trackMoengageEvent("Page Visit", {
      Page: "Portfolio",
    });
    fetchLiveRequest(contestId);
    fetchRequestUser();
  }, []);

  async function PullToRefresh() {
    setLoading(true);
    await fetchLiveRequest(contestId);
    setLoading(false);
  }

  useEffect(() => {
    if (tab) {
      onTabBtnPress(true);
    } else {
      onTabBtnPress(false);
    }
  }, [tab]);

  const onTabBtnPress = async val => {
    setIsLiveSelected(val);
    if (!val) {
      trackMoengageEvent("Clicked on Closed Portfolio", {});
      const res = await Network.closeMarketHeader();
      if (res?.data?.success) {
        setClosedHeader(res.data.historyHeader);
      } else {
      }
    }
  };

  const onClosedPortfolioClick = item => {
    if (isMobile()) {
      navigation.push("PortfolioStack", {
        screen: "closedPortfolioDetail",
        params: {selectedClosedProbe: item},
      });
    } else {
      setSelectedClosedProbe(item);
    }
  };

  const onBottomSheetClose = (e, isClosed = false) => {
    setSelectedOpenProbe(null);
    setApiResponseUiData({
      isShow: false,
      orderData: null,
    });
  };

  // usePolling(
  //   () => {
  //     //fetchLiveRequest(contestId);
  //   },
  //   5000,
  //   isLiveSelected,
  // );

  const onSuccessOrder = useCallback(
    (orderStatus, isMergeOrder = false, removeLiquidity = false) => {
      if (orderStatus) {
        setApiResponseUiData({
          isShow: true,
          orderData: orderStatus,
          isMergeShare: isMergeOrder,
          removeLiquidity: removeLiquidity,
        });
        trackMoengageEvent("order status portfolio", {
          executed: orderStatus?.success
            ? orderStatus?.unmatched > 0
              ? "partial"
              : "success"
            : "failed",
        });
        fetchLiveRequest(contestId);
        fetchRequestUser();
      } else {
        setSelectedOpenProbe(null);
        setApiResponseUiData({isShow: false, orderData: null});
      }
    },
    [],
  );

  const unsubscribe = () => {
    if (wsConnected === 1 && ws && selectedOpenProbe?.probe?.id) {
      try {
        ws.send(
          JSON.stringify({
            topic: contestId
              ? `fantasy-probe-detail_${selectedOpenProbe?.probe?.id}`
              : `probe-detail_${selectedOpenProbe?.probe?.id}`,
            action: "unsubscribe",
          }),
        );
      } catch (e) {}
    }
  };

  const LiveComponent = useCallback(() => {
    var isLiq = false;
    const IndexProbe = livePortfolioData?.probes?.length
      ? livePortfolioData?.probes?.length
      : -1;
    const a = [...livePortfolioData?.probes, ...livePortfolioData?.liquidity];
    console.log("rednr");

    return (
      <View style={[globalImport.isWeb ? {flex: 1} : {marginBottom: 0}]}>
        <FlatList
          keyboardShouldPersistTaps={"handled"}
          ListEmptyComponent={handleEmpty}
          data={a}
          renderItem={({item, index}) => {
            // if (item === 5 && isLiq) {
            //   isLiq = true;
            //   return null;
            // }
            return (
              <>
                {IndexProbe > index ? (
                  contestId ? (
                    <ContestPortfolioLiveCard
                      item={item}
                      onSellCancelClick={onListItemClick}
                      contestId={contestId}
                    />
                  ) : (
                    <PortfolioLiveCard
                      item={item}
                      onSellCancelClick={onListItemClick}
                      // navigation={navigation}
                      contestId={contestId}
                    />
                  )
                ) : (
                  <PortfolioRemoveLiquidity
                    item={item}
                    onSellCancelClick={onListItemClick}
                    navigation={navigation}
                    contestId={contestId}
                  />
                )}
              </>
            );
          }}
          ListHeaderComponent={() => {
            return (
              <>
                {!contestId ? (
                  <PortfolioSummary
                    isLiveChecked={isLiveSelected}
                    closedHeader={closedHeader}
                    data1={livePortfolioData}
                  />
                ) : null}
              </>
            );
          }}
          scrollEnabled={true}
          showsVerticalScrollIndicator={false}
          contentContainerStyle={{paddingBottom: 100}}
          //ListEmptyComponent={ListEmptyComponent}
          keyExtractor={(item, index) => item + ""}
          bounces={false}
          initialNumToRender={5}
          onRefresh={PullToRefresh}
          //onEndReachedThreshold={0.2}
          refreshing={false}
          refreshControl={
            isMobile() ? (
              <RefreshControl
                colors={[Color.tradexBlue]}
                refreshing={loading}
                onRefresh={PullToRefresh}
              />
            ) : null
          }
          //ListFooterComponent={renderFooter}
          //onRefresh={PullToRefresh}
        />
      </View>
    );
  }, [livePortfolioData?.probes, loading]);

  const FormElement = useCallback(() => {
    return selectedOpenProbe ? (
      <BuySell
        _eventInfo={selectedOpenProbe}
        onTradeClickReloadEventApi={onSuccessOrder}
        isPortfolio={true}
        apiRespnseUiData={apiRespnseUiData}
        closeSheet={onBottomSheetClose}
      />
    ) : (
      <FastImage
        style={{height: 600}}
        source={globalConfigurableData.nothing_card_live()}></FastImage>
    );
  }, [selectedOpenProbe, onSuccessOrder, apiRespnseUiData]);

  const ClosedElement = useCallback(() => {
    return selectedClosedProbe ? (
      <View>
        <ClosedPortfolioDetail
          selectedClosedProbe1={selectedClosedProbe}></ClosedPortfolioDetail>
      </View>
    ) : (
      <FastImage
        style={{height: 600}}
        source={globalConfigurableData.nothing_card_closed()}></FastImage>
    );
  }, [selectedClosedProbe]);

  useFocusEffect(
    React.useCallback(() => {
      if (
        wsConnected === 1 &&
        ws &&
        selectedOpenProbe?.probe?.is_price_editable &&
        !selectedOpenProbe?.isMerge &&
        !selectedOpenProbe?.isCancel &&
        !selectedOpenProbe?.isRemoveShare &&
        moment().unix() <= moment.utc(selectedOpenProbe?.probe?.endsat).unix()
      ) {
        try {
          ws.send(
            JSON.stringify({
              topic: contestId
                ? `fantasy-probe-detail_${selectedOpenProbe?.probe?.id}`
                : `probe-detail_${selectedOpenProbe?.probe?.id}`,
              action: "subscribe",
            }),
          );
        } catch (e) {}
      }
      return () => {
        unsubscribe();
      };
    }, [selectedOpenProbe, ws, wsConnected]),
  );

  const BuySellForms = () => {
    return (
      <BuySell
        _eventInfo={selectedOpenProbe}
        onTradeClickReloadEventApi={onSuccessOrder}
        isPortfolio={true}
        apiRespnseUiData={apiRespnseUiData}
        closeSheet={onBottomSheetClose}
      />
    );
  };

  const onListItemClick = useCallback(
    ({
      probe,
      isYes,
      isCancel = false,
      event,
      call = null,
      isMerge = false,
      isRemoveShare = false,
      isCancelAll = false,
    }) => {
      if (apiRespnseUiData?.isShow) {
        setApiResponseUiData({isShow: false, orderData: null});
      }
      const closedMarketScreen = isCancel
        ? ORDER_STATUS_CLOSED_CANCEL
        : ORDER_STATUS_CLOSED_SELL;

      if (isCancel) {
        if (isCancelAll) {
          trackMoengageEvent("Clicked on Cancel All Orders");
        } else {
          trackMoengageEvent("Clicked on Cancel Order");
        }
      }
      if (!isCancel && !isMerge) {
        trackMoengageEvent("sell_order_click");
      }

      if (moment.utc(new Date()).unix() > moment.utc(probe?.endsat).unix()) {
        setApiResponseUiData({
          isShow: true,
          orderData: closedMarketScreen,
        });
      }
      setSelectedOpenProbe({
        probe,
        isYes,
        isCancel,
        call,
        isMerge,
        isRemoveShare,
        isCancelAll,
        isShow: true,
      });
    },
    [apiRespnseUiData],
  );

  const onListItemClick1 = ({
    probe,
    isYes,
    isCancel = false,
    event,
    call = null,
    isMerge = false,
    isRemoveShare = false,
  }) => {
    if (apiRespnseUiData?.isShow) {
      setApiResponseUiData({isShow: false, orderData: null});
    }
    const closedMarketScreen = isCancel
      ? ORDER_STATUS_CLOSED_CANCEL
      : ORDER_STATUS_CLOSED_SELL;

    if (isCancel) {
      trackMoengageEvent("Clicked on Cancel Order");
    }
    if (!isCancel && !isMerge) {
      trackMoengageEvent("sell_order_click");
    }

    if (moment.utc(new Date()).unix() > moment.utc(probe?.endsat).unix()) {
      setApiResponseUiData({
        isShow: true,
        orderData: closedMarketScreen,
      });
    }
    setSelectedOpenProbe({
      probe,
      isYes,
      isCancel,
      call,
      isMerge,
      isRemoveShare,
      isShow: true,
    });

    //event.preventDefault();
  };
  const handleEmpty = () => {
    return (
      <NoMarket
        innerContestCondition={contestId ? true : false}
        source={contestId ? "contest_portfolio" : "portfolio"}
      />
    );
  };

  return (
    <SafeAreaView
      contentContainerStyle={{flexGrow: 1}}
      style={[
        {
          // backgroundColor: Color.bgWhite,
          paddingHorizontal: contestParentId ? 0 : 16,
          paddingBottom: 0,
        },
        globalStyle.scroll_webFix,
      ]}>
      <CommonModal
        onModalCallBack={onBottomSheetClose}
        customModalStyle={[globalStyle.modalView]}
        showModal={(selectedOpenProbe?.isShow && isMobile()) || false}>
        {isMobile() && <View>{selectedOpenProbe ? FormElement() : null}</View>}
      </CommonModal>
      <View style={{marginHorizontal: -16}}>
        {!isMobile() ? (
          <Header selected={"Portfolio"} />
        ) : contestId && !contestParentId ? (
          <Header
            isInternalPage={false}
            navigation={navigation}
            pageName={"Portfolio"}
            isBackgroundColor={false}
          />
        ) : !contestParentId ? (
          <FormTextLabel
            labelStyles={[
              globalStyle.headerContainer,
              {
                ...globalFontStyle.appBlueHead,
                color: globalConfigurableData.primaryTextColor1,
              },
            ]}
            label={"Portfolio"}
          />
        ) : null}
      </View>

      <View
        style={[
          {flexDirection: "row", flex: 1},
          !isMobile() ? {paddingHorizontal: 0} : {},
        ]}>
        <View style={{paddingTop: 0, flex: 1}}>
          <View
            style={[
              {
                flexDirection: "row",
                alignItems: "center",
                marginTop: 12,
                backgroundColor: globalConfigurableData.newSwitchTabBgColor,
                borderRadius: 8,
                paddingVertical: 3,
                paddingHorizontal: 6,
              },
            ]}>
            <View style={{flexDirection: "row", alignItems: "center", flex: 1}}>
              {!contestParentId ? (
                !contestId ? (
                  <FormTextLabel
                    onPress={() => onTabBtnPress(true)}
                    labelStyles={
                      isLiveSelected
                        ? styles.headerOptionsSelected
                        : styles.headerOptions
                    }
                    label={"Open Positions"}
                  />
                ) : null
              ) : null}
            </View>

            {!contestId ? (
              <FormTextLabel
                onPress={() => onTabBtnPress(false)}
                labelStyles={
                  !isLiveSelected
                    ? styles.headerOptionsSelected
                    : styles.headerOptions
                }
                label={"Closed Positions"}
              />
            ) : null}
          </View>
          {isLiveSelected ? (
            <>{LiveComponent()}</>
          ) : (
            <PortfolioParentClosed
              onClosedPortfolioClick={onClosedPortfolioClick}
              closedHeader={closedHeader}
              navigation={navigation}
              isLiveSelected={isLiveSelected}
              livePortfolioData={livePortfolioData}
            />
          )}
        </View>
        {!isMobile() &&
          (isLiveSelected ? (
            <View style={{flex: 0.5, marginLeft: 20, marginTop: 20}}>
              {FormElement()}
            </View>
          ) : (
            <View style={{flex: 0.5, marginLeft: 20, marginTop: 20}}>
              {ClosedElement()}
            </View>
          ))}
      </View>
    </SafeAreaView>
  );
};

const mapStateToProps = ({portfolioReducer, liveReducer}, ownProps) => {
  let data;
  if (ownProps?.route?.params?.contestId || ownProps?.contestParentId) {
    data = portfolioReducer?.portfolioDataContest;
  } else {
    data = portfolioReducer?.data;
  }
  return {
    livePortfolioData: data,
    wsConnected: liveReducer?.connected,
    ws: liveReducer?.wsRef,
  };
};

const mapDispatchToProps = {
  fetchLivePorfolio,
  getUser,
};

const WrappedPortfolio = (props) => (
  <ProtectedRoute>
    <Portfolio {...props} />
  </ProtectedRoute>
);

export default connect(mapStateToProps, mapDispatchToProps)(WrappedPortfolio);

const styles = StyleSheet.create({
  yesNoBtnStyle: {
    paddingHorizontal: 16,
    paddingVertical: 5,
    alignItems: "center",
  },
  externalBorderStyle: {
    flexDirection: "row",
    borderBottomColor: "black",
    borderBottomWidth: StyleSheet.hairlineWidth,
    alignSelf: "flex-start",
  },
  headerOptions: {
    ...globalFontStyle.appFontHeadingRegular,
    color: globalConfigurableData.secondaryTextColor1,
    paddingVertical: 6,
    textAlign: "center",
    flex: 1,
  },
  headerOptionsSelected: {
    ...globalFontStyle.appFontHeading,
    color: globalConfigurableData.primaryTextColor1,
    paddingVertical: 6,
    backgroundColor: globalConfigurableData.newSwitchTabSelectedBgColor,
    borderRadius: 12,
    textAlign: "center",
    flex: 1,
    shadowColor: "#000",
    shadowOffset: {
      width: 1,
      height: 1,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3,
    elevation: 2,
  },
  selectedTab: {
    ...globalFontStyle.appFontSubHeading,
  },
});
